export default "__VITE_ASSET___JJ7eSUA__"